const getModuleState = (state) => state.promotions;

export const getPromotionsGlobalState = (state) => getModuleState(state);
export const getAllPromotions = (state) => getModuleState(state).allPromotions;
export const getActivePromotions = (state) => getModuleState(state).activePromotions;
export const getPromotion = (state) => getModuleState(state).promotion;